import { createContext, useContext } from 'react';

/**
 * Kontekst, przez ktory `FormField` przekazuje kontrolce identyfikatory
 * i stan bledu. Dzieki temu `<FormField label="…"><Input /></FormField>`
 * automatycznie poprawnie spina etykiete, opis i komunikat bledu
 * (`id`, `aria-describedby`, `aria-invalid`) bez recznego przepisywania ich
 * w kazdym formularzu.
 */
export interface FormFieldContextValue {
  controlId: string;
  describedBy: string | undefined;
  invalid: boolean;
  required: boolean;
}

export const FormFieldContext = createContext<FormFieldContextValue | null>(null);

/** Zwraca kontekst pola formularza albo `null`, gdy kontrolka stoi samodzielnie. */
export function useFormFieldContext(): FormFieldContextValue | null {
  return useContext(FormFieldContext);
}
